/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { tenantsGet } from "../../funcs/tenantsGet.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  tenantId: z.string(),
};

export const tool$tenantsGet: ToolDefinition<typeof args> = {
  name: "tenants-get",
  description: `Get Tenant

Retrieves details for a specific tenant.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsGet(
      client,
      args.tenantId,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
